import React, { ReactElement, useMemo } from 'react';
import { AppInsightsProvider } from '@exxonmobil/uit-uda-ui-components-lib';
import { Alert } from 'antd';

type ErrorBoundaryProps = {
  children: ReactElement;
};

export const ErrorBoundary = ({
  children
}: ErrorBoundaryProps): ReactElement => {
  const errorMessage = useMemo(() => {
    return (
      <Alert
        message="Error"
        description="Something went wrong with AION"
        type="error"
      />
    );
  }, []);

  return (
    <AppInsightsProvider onError={() => errorMessage}>
      {children}
    </AppInsightsProvider>
  );
};
